import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { buildFilteredHighlightedProducts } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { FaqsConfig } from '../../constants/faqs/FaqsConfig';
import { getMerchCardsToShow } from '../../constants/merchCards/MerchCardsToShow';
import { NavItemEnum } from '../../constants/routing/NavItems';
import Screens from '../../constants/routing/Screens';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useFeatureStore } from '../../hooks/useFeatureStore';
import useIsEligibleForHsfxDiscount from '../../hooks/useIsEligibleForHsfxDiscount';
import { useTrackRetail } from '../../hooks/useTrackRetail';
import BannerSection from '../banners/BannerSection';
import PhoneSupport from '../common/PhoneSupport';
import ProductInfoContainer from '../common/ProductInfoContainer';
import CodeSplitEnvWrapper from '../common/env/CodeSplitEnvWrapper';
import CompareStatusFooter from '../compare/CompareStatusFooter';
import Faq from '../faqs/Faq';
import FooterMicrocopy from '../faqs/FooterMicrocopy';
import Question from '../faqs/Question';
import SuiteFeatureTable from '../feature-table/suite-feature-table/SuiteFeatureTable';
import HeaderLayout from '../layout/HeaderLayout';
import { SuiteTiles } from '../merch-card/SuiteTiles';
import ComparePlansLink from '../personalized-pricing-page/suite-starter-page/ComparePlansLink';
import ProductPageSubtitle from '../product-pages/ProductPageSubtitle';
import ProductPageTitle, { ProductPageHeader } from '../product-pages/ProductPageTitle';
import WhyGoHubSpotSection from './WhyGoHubSpotSection';

const FreeToolsPage = () => {
  useDocumentTitle('crm');
  useTrackRetail();
  const eligibleForHsfxDiscount = useIsEligibleForHsfxDiscount();
  useEffect(() => {
    getUsageTracker().setProperties({
      defaultedTab: '',
      tab: ''
    });
    getUsageTracker().track('pageView', {
      screen: Screens.FREE
    });
  }, []);
  const productLevels = getMerchCardsToShow({
    isFreeToStarter: true
  });
  const marketingHighlightedProducts = buildFilteredHighlightedProducts({
    productLine: MARKETING,
    productLevels
  });
  useFeatureStore({
    highlightedProducts: marketingHighlightedProducts,
    productLine: MARKETING
  });
  const salesHighlightedProducts = buildFilteredHighlightedProducts({
    productLevels,
    productLine: SALES
  });
  useFeatureStore({
    highlightedProducts: salesHighlightedProducts,
    productLine: SALES
  });
  const serviceHighlightedProducts = buildFilteredHighlightedProducts({
    productLevels,
    productLine: SERVICE
  });
  useFeatureStore({
    highlightedProducts: serviceHighlightedProducts,
    productLine: SERVICE
  });
  const operationsHighlightedProducts = buildFilteredHighlightedProducts({
    productLevels,
    productLine: OPERATIONS
  });
  useFeatureStore({
    highlightedProducts: operationsHighlightedProducts,
    productLine: OPERATIONS
  });
  const cmsHighlightedProducts = buildFilteredHighlightedProducts({
    productLevels,
    productLine: CMS
  });
  useFeatureStore({
    highlightedProducts: cmsHighlightedProducts,
    productLine: CMS
  });
  const productsByProductLine = {
    [MARKETING]: marketingHighlightedProducts,
    [SALES]: salesHighlightedProducts,
    [SERVICE]: serviceHighlightedProducts,
    [OPERATIONS]: operationsHighlightedProducts,
    [CMS]: cmsHighlightedProducts
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      "data-selenium-id": "page-success",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "FREE_TOOLS_PAGE"
      }), /*#__PURE__*/_jsx(HeaderLayout, {
        selectedNavItem: NavItemEnum.FREE,
        children: /*#__PURE__*/_jsxs(ProductInfoContainer, {
          children: [eligibleForHsfxDiscount && /*#__PURE__*/_jsx(BannerSection, {
            screen: NavItemEnum.FREE
          }), /*#__PURE__*/_jsxs(ProductPageHeader, {
            children: [/*#__PURE__*/_jsx(ProductPageTitle, {
              nonProductIdentifier: NavItemEnum.FREE
            }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
              nonProductIdentifier: NavItemEnum.FREE
            })]
          }), /*#__PURE__*/_jsx(SuiteTiles, {
            isFreeToStarter: true
          }), /*#__PURE__*/_jsx(ComparePlansLink, {}), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
            authedComponentLoader: () => import(
            /* webpackChunkName: "authed-chunk" */
            `pricing-pages-ui/components/personalized-pricing-page/suite-starter-page/feature-interest/FeatureInterestAndLimitUsageSection`),
            authedComponentProps: {}
          }), /*#__PURE__*/_jsx(SuiteFeatureTable, {
            productsByProductLine: productsByProductLine,
            screen: Screens.FREE,
            isFreeToStarter: true
          }), /*#__PURE__*/_jsx(WhyGoHubSpotSection, {
            selectedNavItem: NavItemEnum.FREE
          }), /*#__PURE__*/_jsx(PhoneSupport, {
            phoneSourceId: "crm-middle",
            screen: Screens.FREE
          }), /*#__PURE__*/_jsxs(Faq, {
            children: [FaqsConfig[NavItemEnum.FREE].map((_ref) => {
              let {
                questionKey
              } = _ref,
                  passthroughOptions = _objectWithoutPropertiesLoose(_ref, ["questionKey"]);

              return /*#__PURE__*/_jsx(Question, Object.assign({
                questionKey: questionKey
              }, passthroughOptions), questionKey);
            }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
          })]
        })
      }), /*#__PURE__*/_jsx(CompareStatusFooter, {})]
    })
  });
};

export default FreeToolsPage;